module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "academics-top-right.6800c16f.jpeg" + "?" + Date.now();